import { Card, Row, Col, Button } from '@themesberg/react-bootstrap'
import React, { useState } from 'react'
import { ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSetRecoilState } from 'recoil';
import { Form, Input, Upload, Button as AntButton, Modal, Space, Tooltip } from 'antd';
import { dummyRequest, getHtml, getRawData } from '../../../services/utilities';
import { activateBankFeature, activateListItems, activatePayFeature, createListItems, deleteListItems, deletePay, updateListItem, updatePayFeature } from '../../../services/apiCalls';
import { faCheckSquare, faEdit, faExclamation, faPlus, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { featureAlert, featureResponse, posRefresh } from '../../../states/wayaPos';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';

const GramListCard = ({ img, description, status, type, position, link, google_url, app_url, get_start_url, name, link_url, title, listItem, id, featureImg }) => {
  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState()
  const [createModal, setCreateModal] = useState(false)
  const [createListModal, setCreateListModal] = useState(false)
  const [viewModal, setViewModal] = useState(false)
  const [updatList, setUpdatList] = useState([])
  const [editor, setEditor] = useState("")
  const [editorDesc, setEditorDesc] = useState("")
  const setShowAlert = useSetRecoilState(featureAlert);
  const setResponse = useSetRecoilState(featureResponse)
  const setRefresh = useSetRecoilState(posRefresh)
  const [form] = Form.useForm()
  const { confirm } = Modal;

  const onFinish = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    // fd.append('title', val.title)
    // fd.append('description', val.description)
    // fd.append('position', val.position)
    // fd.append('link_url', val.link_url)
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    fd.append('position', val.position)
    fd.append('google_url', val.google_url)
    fd.append('app_store_url', val.app_store_url)
    fd.append('get_start_url', val.get_start_url)
    fd.append('link2_url', val.link2_url)
    fd.append('file', file);
    try {
      const res = await updatePayFeature({ data: fd, id })
      if (res.status) {
        setResponse({ message: res.message, title: "success" })
        setShowAlert(true)
        setRefresh(date.toTimeString())
        setCreateModal(false)
        setFile('')
      } else {
        setResponse({ message: res.message || res, title: "failed" })
        setShowAlert(true)
        setFile()
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
    setFile()
  }
  
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };
  const handleUpdate = () => {
    setCreateModal(true)
      if (title) {
        const contentState = getRawData(title)
        setEditor(EditorState.createWithContent(contentState));
      }
      if (description) {
        const contentStateDesc = getRawData(description)
        setEditorDesc(EditorState.createWithContent(contentStateDesc));
      }
    // setValue(val)
  }

  // const onFinishList = async (val) => {
  //   console.log(val)
  //   setLoading(true)
  //   const date = new Date()
  //   const fd = new FormData();
  //   fd.append('title', val.title)
  //   fd.append('type', val.type)
  //   fd.append('parent_id', val.parent_id)
  //   fd.append('file', file);
  //   const res = await createListItems(fd)
  //   if (res.status) {
  //     setResponse({ message: res.message, title: "success" })
  //     setShowAlert(true)
  //     setRefresh(date.toTimeString())
  //     setViewModal(false)
  //     form.resetFields()
  //   } else {
  //     setResponse({ message: res.message || res, title: "failed" })
  //     setShowAlert(true)
  //     form.resetFields()
  //   }
  //   setLoading(false)
  //   form.resetFields()
  // }
  const onFinishList = async (val) => {
    console.log(val)
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    // fd.append('title', val.title)
    // fd.append('description', val.description)
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    fd.append('type', val.type)
    fd.append('parent_id', val.parent_id)
    fd.append('file', file);
    const res = await createListItems(fd)
    // const res = await createListItems(val)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewModal(false)
      form.resetFields()
      setEditor('')
      setEditorDesc('')
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
    }
    setLoading(false)
    form.resetFields()
  }
  
  const upDateList = async (data) => {
    const id = updatList.id
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    fd.append('file', file);
    const res = await updateListItem({ fd, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setCreateListModal(false)
      setEditor('')
      setEditorDesc('')
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
      setEditor('')
      setEditorDesc('')
    }
    setLoading(false)
    form.resetFields()
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  const offVul = (id) => {
    const data = {status: 0}
    console.log(id)
    confirm({
      title: `Are you sure you want to activate ${name}?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onVul = (id) => {
    const data = {status: 1}
    console.log(id)
    confirm({
      title: `Are you sure you want to activate ${name}?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleShowHide = async (id, status) => {
    const date = new Date()
    console.log(id)
    console.log(status)
    const res = await activatePayFeature({ data: status, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  const confirmDelete = (id) => {
    confirm({
      title: `Are you sure you want to delete this Post?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDelete(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDelete = async (id) => {
    const date = new Date()
    const res = await deletePay(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  
  const offList = (id) => {
    const data = {status: 0}
    confirm({
      title: `Are you sure you want to deactivate ${title} Item?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        listShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onList = (id) => {
    const data = {status: 1}
    confirm({
      title: `Are you sure you want to activate ${title} Item?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        listShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const listShowHide = async (id, status) => {
    const date = new Date()
    const res = await activateListItems({ data: status, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  
  const confirmDeleteList = (id) => {
    confirm({
      title: `Are you sure you want to delete this Post?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDeleteList(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDeleteList = async (id) => {
    const date = new Date()
    const res = await deleteListItems(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  const openUpdate = (e)=>{
    setCreateListModal(true)
    setUpdatList(e)
      if (e.title) {
        const contentState = getRawData(e.title)
        setEditor(EditorState.createWithContent(contentState));
      }
      if (e.description) {
        const contentStateDesc = getRawData(e.description)
        setEditorDesc(EditorState.createWithContent(contentStateDesc));
      }
  }

  return (
    <>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          {type === "POS" ? 
            <Row>
              <Col xs={12} md={6} xl={6} lg={6}>                
                {featureImg && 
                  <img src={img} style={{width:'60%'}} alt="features" />
                }
                {/* <h5>{title}</h5>
                <p>{description === 'undefined' ? '' : description}</p> */}
                <p dangerouslySetInnerHTML={{ __html: title }} />
                <p dangerouslySetInnerHTML={{ __html: description === 'undefined' ? '' : description}} />
                <Button variant="success" size="sm" className="text-white me-2" onClick={() => handleUpdate()}>
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
                <Button size="sm" variant="primary" className="text-white m-2" onClick={() => confirmDelete(id)}>
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
                {status === 1 ?
                <Button variant="primary" size="sm" className="text-white me-3" onClick={()=>offVul(id)}>
                  Deactivate
                </Button>:
                <Button variant="secondary" size="sm" className="text-white me-3" onClick={()=>onVul(id)}>
                  Activate
                </Button>
              }
              </Col>              
              <Col xs={12} md={6} xl={6} lg={6}>
                <div>
                  <div className="table-settings mb-2">
                    <Button variant="success" className="text-white me-3" onClick={() => setViewModal(true)}>
                        Create New Feature <FontAwesomeIcon icon={faPlus} className="d-none d-sm-inline ms-1" />
                    </Button>
                  </div>
                  <div>
                    {listItem.map(list=>(
                      <Row key={list.id} className='border border-2px border-solid'>
                        <Col xs={12} md={8} xl={8} lg={8}>
                          {featureImg === false && 
                            <img src={list.image_url} className='pt-2' height='50' width='50' alt="features" />
                          }
                          <h6 className='py-2'>
                            {/* {list.title} */}
                            <p dangerouslySetInnerHTML={{ __html: list.title }} />
                            {/* <p dangerouslySetInnerHTML={{ __html: description === 'undefined' ? '' : description}} /> */}
                          </h6>
                        </Col>                      
                        <Col xs={12} md={4} xl={4} lg={4}>
                          <Button variant="success" size="sm" className="text-white m-1" onClick={() => openUpdate(list)}>
                            <FontAwesomeIcon icon={faEdit} />
                          </Button>
                          <Button size="sm" variant="primary" className="text-white m-1" onClick={() => confirmDeleteList(list.id)}>
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                          {list.status === 1 ?
                            <Button variant="primary" size="sm" className="text-white m-1" onClick={()=>offList(list.id)}>
                              <FontAwesomeIcon icon={faTimes} />
                            </Button>:
                            <Button variant="secondary" size="sm" className="text-white m-1" onClick={()=>onList(list.id)}>
                              <FontAwesomeIcon icon={faCheckSquare} />
                            </Button>
                          }
                        </Col>
                      </Row>
                    ))}
                  </div>
                </div>
              </Col>
            </Row> 
          : 
            <Row>
              <Col xs={12} md={12} xl={12} lg={12}>                
                {featureImg && 
                  <img src={img} width={75} alt="features" />
                }
                {/* <h5>{title}</h5> */}
                <p dangerouslySetInnerHTML={{ __html: title }} />
                {/* <p dangerouslySetInnerHTML={{ __html: description === 'undefined' ? '' : description}} /> */}
                {/* <p>{description === 'undefined' ? '' : description}</p> */}
                <Button variant="success" size="sm" className="text-white me-2" onClick={() => handleUpdate()}>
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
                <Button size="sm" variant="primary" className="text-white m-2" onClick={() => confirmDelete(id)}>
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
                {status === 1 ?
                <Button variant="primary" size="sm" className="text-white me-3" onClick={()=>offVul(id)}>
                  Deactivate
                </Button>:
                <Button variant="secondary" size="sm" className="text-white me-3" onClick={()=>onVul(id)}>
                  Activate
                </Button>
              }
              </Col>              
              <Col xs={12} md={12} xl={12} lg={12}>
                <div>
                  <div className="table-settings mb-2">
                    <Button variant="success" className="text-white me-3" onClick={() => setViewModal(true)}>
                        Create New Feature <FontAwesomeIcon icon={faPlus} className="d-none d-sm-inline ms-1" />
                    </Button>
                  </div>
                  <div>
                    <Row className=''>
                      {listItem.map(list=>(
                        <Col xs={12} md={4} xl={4} key={list.id} lg={4}>
                          <div className='card p-2'>
                            {/* {featureImg === false &&  */}
                              <img src={list.image_url} className='pt-2' height='50' width='50' alt="features" />
                            {/* } */}
                            {/* <h6 className='py-2'>
                              {list.title}
                            </h6>
                            <p>{list.description}</p> */}
                            <p dangerouslySetInnerHTML={{ __html: list.title }} />
                            <p dangerouslySetInnerHTML={{ __html: list.description === 'undefined' ? '' : list.description}} />
                            <Space size="small">
                              <Tooltip title='Edit'>
                                <AntButton type="ghost" onClick={() => openUpdate(list)}>
                                  <FontAwesomeIcon icon={faEdit} />
                                </AntButton>
                              </Tooltip>
                              <Tooltip title='Delete'>
                                <AntButton type="danger" onClick={() => confirmDeleteList(list.id)}>
                                  <FontAwesomeIcon icon={faTrash} />
                                </AntButton>
                              </Tooltip>
                              {list.status === 1 ?
                                <Tooltip title='Deactivate'>
                                  <AntButton type="danger" onClick={()=>offList(list.id)}>
                                    Deactivate
                                  </AntButton>
                                </Tooltip>:
                                <Tooltip title='Activate'>
                                  <AntButton type="primary" onClick={()=>onList(list.id)}>
                                    Activate
                                  </AntButton>
                                </Tooltip>
                              }
                            </Space>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          }
        </Card.Body>
      </Card>
      {/*update merchant hero start */}
      <Modal
        title="Update Waya Pay Content "
        centered
        visible={createModal}
        footer={null}
        onCancel={() => setCreateModal(false)}
      >
        <Form form={form} onFinish={onFinish} layout="vertical" initialValues={{ title, position, google_url, app_url, get_start_url, link_url, description, image_url: img }}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 85,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item label="Description">
            {/* <Input.TextArea /> */}
            <Editor
              editorState={editorDesc}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 140,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            />
          </Form.Item>
            <Form.Item label="Position" name="position">
              <Input type='number' />
            </Form.Item>
            <Form.Item label="Google Play Link" name="google_url">
              <Input />
            </Form.Item>
            <Form.Item label="App Store Link" name="app_url">
              <Input />
            </Form.Item>
            <Form.Item label="Get Started Link" name="get_start_url">
              <Input />
            </Form.Item>
          {/* {link && */}
            {/* <Form.Item label="Button URL" name="link_url">
              <Input />
            </Form.Item> */}
          {/* } */}
          {featureImg &&
            <Form.Item >
              <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                <AntButton icon={<InboxOutlined />}>Upload Image</AntButton>
              </Upload>
            </Form.Item>}
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/**update merchant hero end */}
      
      {/**Create List hero end */}
      <Modal
        title="Create New List"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        <Form form={form} onFinish={onFinishList} layout="vertical">
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 85,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          {type === 'SEC' &&
          <>
            <Form.Item label="Description" name="description">
              {/* <Input.TextArea /> */}
            <Editor
              editorState={editorDesc}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 140,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            />
            </Form.Item>
            <Form.Item >
              <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                <AntButton icon={<InboxOutlined />}>Upload Image</AntButton>
              </Upload>
            </Form.Item>
          </>
          }
          <Form.Item initialValue={id} hidden name="parent_id">
            <Input hidden />
          </Form.Item>
          <Form.Item initialValue='pos' hidden name="type">
            <Input hidden />
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Create
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      
      {/**Create List hero end */}
      {/**Create List hero end */}
      <Modal
        title="Update List"
        centered
        visible={createListModal}
        footer={null}
        onCancel={() => setCreateListModal(false)}
      >
        <Form form={form} onFinish={upDateList} layout="vertical">
          <Form.Item label="Edit Title" initialValue={updatList.title} name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 85,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          {/* {type === 'SEC' &&
            <Form.Item label="Description" initialValue={updatList.description} name="description">
              <Input.TextArea />
            </Form.Item>
          } */}
          {type === 'SEC' &&
              <>
              <Form.Item label="Description" name="description">
                {/* <Input.TextArea /> */}
              <Editor
                editorState={editorDesc}
                editorClassName="px-3 border border-gray-1"
                editorStyle={{
                  height: 140,
                  overflow: 'auto',
                }}
                onEditorStateChange={onEditorStateChanges}
              />
              </Form.Item>
              <Form.Item >
                <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                  <AntButton icon={<InboxOutlined />}>Upload Image</AntButton>
                </Upload>
              </Form.Item>
            </>
          }
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      
      {/**Create List hero end */}
    </>
  )
}

export default GramListCard
